import { render, staticRenderFns } from "./ApOrderDetail.vue?vue&type=template&id=781c946a&"
import script from "./ApOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ApOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApOrderDetail.vue"
export default component.exports